import React from 'react';
import {IsacoTypes} from "@/types/isaco";
import IsacoListItem from "@/app/(pages)/(general)/isaco/components/isaco-listItem";


export default function IsacoList  ({companiesList}: { companiesList: Array<IsacoTypes> }) {

    return (
        <>
            {
                companiesList?.map((item, index) => {
                    return <IsacoListItem
                        key = {index}
                        name = {item.name}
                        car = {item.car}
                        tolidKonande = {item.tolidKonande}
                        code = {item.code}
                        priceUpdate = {item.priceUpdate}
                        priceWithTax = {item.priceWithTax}
                        price = {item.price}
                    />
                })
            }
        </>

    );
};